import config from '@config';
import CTRestRequestFactory from '@core/utils/network/CTRestRequestFactory';
import RestRequestFactory from '@core/utils/network/RestRequestFactory';

export default class RestService {
    private readonly request: any;
    private readonly requestWithCredentials: any;
    private readonly oldProductionRequest: any;

    constructor(
        restRequestFactories = {
            restRequestFactory: RestRequestFactory,
            ctRestRequestFactory: CTRestRequestFactory
        }
    ) {
        this.requestWithCredentials = restRequestFactories.ctRestRequestFactory.create(config.services.user.host, true);
        this.request = restRequestFactories.restRequestFactory.create(config.services.casino.host);
        this.oldProductionRequest = restRequestFactories.restRequestFactory.create(config.services.frontendServer);
    }

    public getAllGames(): Promise<any> {
        return this.request({
            url: '/rest/SBWeb.Models.Casino/getAllGames',
            method: 'get'
        });
    }

    public getXJackpotDetails(): Promise<any> {
        return this.oldProductionRequest({
            url: '/rest/SBWeb.Models.Casino/getXJackpots',
            method: 'get',
            params: {
                details: true,
            }
        });
    }

    public getJackpotBanner(): Promise<any> {
        return this.request({
            url: '/rest/SBWeb.Models.Offer/getJackpotData',
            method: 'get',
        });
    }

    public getFavouriteGames(): Promise<any> {
        return this.requestWithCredentials({
            url: '/casino/getPlayerShortcutGames',
            method: 'get',
        });
    }

    // TODO POST NOT GET
    public toggleFavouriteGame(gameId: number, add: boolean): Promise<any> {
        return this.requestWithCredentials({
            url: `/casino/togglePlayerShortcutGame?GameId=${gameId}&add=${add ? 1 : 0}`,
            method: 'get',
        });
    }

    public launchCasinoGame(externalId: number, isFullGame: boolean, isRealPlay: boolean) {
        return this.requestWithCredentials({
            url: '/casino/launchGame',
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                gameId: externalId,
                fullGame: isFullGame,
                realPlay: isRealPlay,
            }
        });
    }

    public launchLiveLobby(lobbyCategory: string, gameManufacturer: string): Promise<any> {
        return this.requestWithCredentials({
            url: '/casino/launchLiveLobby',
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                lobbyCategory,
                gameManufacturer,
            }
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/game/_private/RestService.ts